import ApexLogo from '../apex-logo.png';
import React, { Component }  from 'react';
import axios from "axios";

export class Header extends Component {
    state = {
        isAdmin:false,
        isMenuOpen: false
    }

    componentDidMount() {
        this.checkRole();
    }
    
    async checkRole(){
        const response = await axios.get('/manage/check-role');
        console.log(response);
        if(response.data === "Admin")
        {
            const isAdmin = true
            this.setState({ isAdmin });
        }
    }

    toggleMenu = () => {
        this.setState(prevState => ({ isMenuOpen: !prevState.isMenuOpen }));
    }

    logout(e) {
        e.preventDefault();
        localStorage.removeItem('token');
        // Clear suppliers-related preferences
        localStorage.removeItem('suppliersSearch');
        localStorage.removeItem('suppliersSelectedOption');
        localStorage.removeItem('suppliersSelectedOptionName');
        localStorage.removeItem('suppliersPageSize');
        // Clear per page preferences
        localStorage.removeItem('rawsPerPage');
        localStorage.removeItem('purchasesPerPage');
        window.location.href = "/login";
    }
    render() {
        return (
            <header className="navigation fixed-top">
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-white">
                        <button 
                            className="navbar-toggler order-0 d-lg-none mobile-menu-toggle" 
                            type="button" 
                            onClick={this.toggleMenu}
                            aria-controls="navigation" 
                            aria-expanded={this.state.isMenuOpen} 
                            aria-label="Toggle navigation"
                            style={{border: '1px solid #ccc', padding: '5px 10px', borderRadius: '4px'}}
                        >
                            <span style={{display: 'block', width: '25px', height: '2px', backgroundColor: '#333', margin: '5px 0'}}></span>
                            <span style={{display: 'block', width: '25px', height: '2px', backgroundColor: '#333', margin: '5px 0'}}></span>
                            <span style={{display: 'block', width: '25px', height: '2px', backgroundColor: '#333', margin: '5px 0'}}></span>
                        </button>
                        <a className="navbar-brand order-1 mobile-logo" href="/suppliers-data">
                            {/*<img className="img-fluid" width="100px" src={Logo} alt="Peak"/>*/}
                            <img className="img-fluid" width="100px" src={ApexLogo} alt="APEX"/>
                        </a>
                        <div className={`navbar-collapse text-center order-lg-2 order-3 ${this.state.isMenuOpen ? 'show' : 'collapse'}`} id="navigation">
                            <ul className="navbar-nav mx-auto">
                                <li className="nav-item menu-border">
                                    <a className="nav-link" href="/suppliers-data"> <i
                                        className={'ti-truck'}></i> Suppliers</a>
                                </li>

                                <li className="nav-item menu-border">
                                    <a className="nav-link" href="/purchases"> <i
                                        className={'ti-shopping-cart'}></i> Purchases</a>
                                </li>

                                <li className="nav-item menu-border">
                                    <a className="nav-link" href="/parts"> <i
                                        className={'ti-package'}></i> Parts</a>
                                </li>

                                <li className="nav-item menu-border">
                                    <a className="nav-link" href="/nutriform"> <i
                                        className={'ti-layout-list-thumb-alt'}></i> NutriFORM</a>
                                </li>

                                <li className="nav-item menu-border">
                                    <a className="nav-link" target={'_blank'} rel={'noreferrer'}
                                       href="http://98.83.67.127:8080/flinkiso/users/login"> <i
                                        className={'ti-harddrives'}></i> APEX-QMS</a>
                                </li>
                                
                                

                                {
                                    this.state.isAdmin === true ? (<li className="nav-item menu-border">
                                        <a className="nav-link" href="/manage"> <i
                                            className={'ti-crown'}></i> Manage</a>
                                    </li>) : (<li></li>)
                                }

                                <li className="nav-item menu-border">
                                    <a className="nav-link" href="/library"> <i
                                        className={'ti-layout-column3'}></i> Library</a>
                                </li>

                                {/*<li className="nav-item menu-border">*/}
                                {/*    <a className="nav-link" href="/dn-reports"> <i*/}
                                {/*        className={'ti-bar-chart'}></i> DN Reports</a>*/}
                                {/*</li>*/}

                                {/*<li className="nav-item menu-border">*/}
                                {/*    <a className="nav-link" href="/home"><i className={'ti-home'}></i> SOW</a>*/}
                                {/*</li>*/}


                                {/*<li className="nav-item menu-border">*/}
                                {/*    <a className="nav-link" href="/upload"> <i className={'ti-upload'}></i> Upload</a>*/}
                                {/*</li>*/}

                            </ul>
                        </div>

                        <div className="order-2 order-lg-3 d-flex align-items-center mobile-logout">
                            <button onClick={(event) => {
                                this.logout(event)
                            }} className="border-0" type="button"
                                    style={{background:'none'}}>
                                <i className="ti-user"></i> <span className="d-none d-md-inline">Logout</span>
                            </button>
                        </div>

                    </nav>
                </div>
            </header>
        )
    }
}

    export default Header;